// extracted by mini-css-extract-plugin
module.exports = {"edit_modal":"index_edit_modal__GIsNA","close":"index_close__H2rvU","wrapper":"index_wrapper__f2rWW"};